import React from 'react'
import { BiCalendar, BiLinkExternal } from 'react-icons/bi'
import { getDatasetDescription } from './datasetDescriptions'

const PipelineCard = ({ pipelineRun, clickHandler }) => {
    const formatTimestamp = (timestamp) => {
        const date = new Date(timestamp)
        return {
            date: date.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            }),
            time: date.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit'
            })
        }
    }

    const { date, time } = formatTimestamp(pipelineRun.timestamp)
    const description = getDatasetDescription(pipelineRun.dataset, pipelineRun.pipeline)

    return (
        <div className="pipeline-card">
            <div className="dashboard-card-header">
                <h3 className="dashboard-card-title">{pipelineRun.name}</h3>
                <div className="pipeline-badge">
                    <span className="badge-text">{pipelineRun.pipeline}</span>
                </div>
            </div>

            <div className="dashboard-card-content">
                <p className="dashboard-card-description">{description}</p>
                <div className="dashboard-card-meta">
                    <div className="meta-item">
                        <BiCalendar className="meta-icon" />
                        <span className="meta-text">
                            {date} at {time}
                        </span>
                    </div>
                </div>
            </div>

            <div className="dashboard-card-footer">
                <button className="results-button" onClick={clickHandler}>
                    <BiLinkExternal className="button-icon" />
                    View Results
                </button>
            </div>
        </div>
    )
}

export default PipelineCard
